import { render, staticRenderFns } from "./YearsRangeModal.vue?vue&type=template&id=b66b6990&scoped=true&"
import script from "./YearsRangeModal.vue?vue&type=script&lang=js&"
export * from "./YearsRangeModal.vue?vue&type=script&lang=js&"
import style0 from "./YearsRangeModal.vue?vue&type=style&index=0&id=b66b6990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66b6990",
  null
  
)

export default component.exports